import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import WorkWithMe from "./pages/WorkWithMe";
import Testimonials from "./pages/Testimonials";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Resources from "./pages/Resources";
import Contact from "./pages/Contact";
import ForParents from "./pages/ForParents";
import Retreats from "./pages/Retreats";
import HealthConcierge from "./pages/HealthConcierge";
import Unsubscribe from "./pages/Unsubscribe";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/work-with-me" element={<WorkWithMe />} />
            <Route path="/for-parents" element={<ForParents />} />
            <Route path="/retreats" element={<Retreats />} />
            <Route path="/health-concierge" element={<HealthConcierge />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/articles" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/articles/:slug" element={<BlogPost />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
